import React, { useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { Helmet } from "react-helmet-async";
import { website } from "../constants/website";
import { enquiryApi } from "../constants/api"; // named import

// Utility to generate a transaction ID
const generateTransactionId = () => {
  return "txn-" + Date.now() + "-" + Math.floor(Math.random() * 100000);
};

export default function ContactUs(): JSX.Element {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = React.useState({
    name: "",
    phoneNumber: "",
    email: "",
    description: "",
  });

  const [errors, setErrors] = React.useState({
    name: "",
    phoneNumber: "",
    email: "",
    description: "",
  });

  const validate = () => {
    let isValid = true;
    let newErrors = { name: "", phoneNumber: "", email: "", description: "" };

    if (!formData.name.trim()) {
      newErrors.name = "Name is required.";
      isValid = false;
    }
    if (!formData.phoneNumber.trim()) {
      newErrors.phoneNumber = "Phone number required.";
      isValid = false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim() || !emailRegex.test(formData.email)) {
      newErrors.email = "Enter a valid email address.";
      isValid = false;
    }
    if (!formData.description.trim()) {
      newErrors.description = "Description is required.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const submit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);

    const payload = {
      sourceId: generateTransactionId(),
      name: formData.name,
      phone: formData.phoneNumber.startsWith("+")
        ? formData.phoneNumber
        : `+${formData.phoneNumber}`,
      email: formData.email,
      description: formData.description,
      submittedAt: new Date().toISOString(),
    };

    enquiryApi
  
      .post("/medical/medical/public/website-enquiries", payload, {
        
      })
      .then(() => {
        window.alert("Your inquiry has been submitted successfully!");
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error submitting inquiry:", error);
        window.alert("An error occurred. Please try again later.");
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Helmet>
        <title>{website.CONTACT.title}</title>
        <meta name="description" content={website.CONTACT.description} />
        <meta name="keywords" content={website.CONTACT.keywords} />
      </Helmet>
      <div className="page">
        <Header />
        <div className="site-main">
          <section className="prt-row prt-bg bg-base-grey contact-section contact-border-top clearfix">
            <div className="container">
              <div className="row">
                <div className="col-xl-6 col-lg-8 col-md-10 col-sm-11 m-auto">
                  <div className="section-title title-style-center_text">
                    <div className="title-header">
                      <h3 className="prt-contact-pretitle">Contact</h3>
                      <h2 className="title">We’re here to help you</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="prt_contact_widget_wrapper mt-55 res-991-mt-20">
                    <div className="prt_content-block">
                      <div className="row g-0">
                        <div className="col-xl-6 col-lg-12">
                          <div className="pr-40 res-991-pr-0">
                            <p>
                              At Prime Precision Imaging we are dedicated to
                              providing exceptional diagnostic imaging services
                              with a focus on accuracy, compassion, and
                              patient-centric care.
                            </p>
                            <p>
                              For any questions, concerns, or feedback, please
                              fill out the contact form below. We will respond
                              to your message as soon as possible. We're Just a
                              Message Away!
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-12">
                          <div data-aos="fade-up" data-aos-duration="1000">
                            <h3>Fill form to reach us</h3>
                            <form onSubmit={submit} noValidate className="query_form-1 wrap-form clearfix">
                              <div className="row">
                                <div className="col-md-6 mt-2">
                                  <label>Name</label>
                                  <input
                                    name="name"
                                    type="text"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    required
                                  />
                                </div>
                                <div className="col-md-6 mt-2">
                                  <label>Phone Number</label>
                                  <input
                                    name="phoneNumber"
                                    type="number"
                                    placeholder="eg. 2677***"
                                    value={formData.phoneNumber}
                                    onChange={handleInputChange}
                                    required
                                  />
                                </div>
                                <div className="col-md-12 mt-2">
                                  <label>Email</label>
                                  <input
                                    name="email"
                                    type="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    required
                                  />
                                </div>
                                <div className="col-md-12 mt-2">
                                  <label>How can we help you?</label>
                                  <textarea
                                    name="description"
                                    value={formData.description}
                                    onChange={handleInputChange}
                                    required
                                  ></textarea>
                                </div>
                                <div className="col-md-12 mt-2">
                                  <button
                                    className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-skincolor"
                                    type="submit"
                                    disabled={loading}
                                  >
                                    {loading ? "Submitting..." : "Submit"}
                                  </button>
                                  <br />
                                  {loading && (
                                    <div className="d-flex justify-content-center mt-2">
                                      <div className="loading-indicator">
                                        Processing your request... Please wait.!
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <Footer />
      </div>
    </>
  );
}
